import api from './client';

export const getUsers = (id) =>
  api.get('/users', { params: { id } });
